export interface Chapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  slug: string;
  cover: string;
  author: string;
  status: '连载中' | '已完结';
  category: string;
  categorySlug: string;
  description: string;
  rating: number;
  views: number;
  chapters: Chapter[];
  updatedAt: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line', description: '激情澎湃的热血漫画，点燃你的斗志与梦想' },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', description: '欢乐无限的搞笑漫画，让你笑到停不下来' },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', description: '甜蜜动人的恋爱漫画，感受青春的悸动' },
  { name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', description: '天马行空的奇幻漫画，开启异世界冒险之旅' },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑漫画，层层揭开惊人真相' },
  { name: '校园', slug: 'xiaoyuan', icon: 'ri-school-line', description: '青春洋溢的校园漫画，重温那些年的美好时光' },
  { name: '武侠', slug: 'wuxia', icon: 'ri-sword-line', description: '快意恩仇的武侠漫画，仗剑天涯英雄梦' },
  { name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line', description: '脑洞大开的科幻漫画，探索未来无限可能' },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '大黄丫头',
    slug: 'dahuang-yatou',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20featuring%20a%20young%20girl%20with%20warm%20yellow%20and%20orange%20tones%2C%20soft%20watercolor%20style%2C%20clean%20white%20background%20with%20subtle%20gradient%2C%20anime%20art%20style%2C%20delicate%20linework%2C%20warm%20and%20inviting%20atmosphere%2C%20professional%20manga%20cover%20design&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    author: '叮当工作室',
    status: '连载中',
    category: '恋爱',
    categorySlug: 'lianai',
    description: '大黄丫头是一个关于成长与爱情的故事。黄小丫是一个普通的小镇女孩，因为一次偶然的相遇，她的生活从此发生了翻天覆地的变化。在这个充满温暖与感动的故事中，你将跟随黄小丫一起经历青春的酸甜苦辣，感受最纯真的爱情与友情。无删减版本完整呈现每一个精彩瞬间，让您沉浸在这个美好的故事中。',
    rating: 9.6,
    views: 12580000,
    chapters: [
      { id: 'ch1-1', title: '第1话 相遇', number: 1, updatedAt: '2026-08-01' },
      { id: 'ch1-2', title: '第2话 悸动', number: 2, updatedAt: '2026-08-02' },
      { id: 'ch1-3', title: '第3话 告白', number: 3, updatedAt: '2026-08-03' },
      { id: 'ch1-4', title: '第4话 牵手', number: 4, updatedAt: '2026-08-04' },
      { id: 'ch1-5', title: '第5话 误会', number: 5, updatedAt: '2026-08-05' },
    ],
    updatedAt: '2026-08-04',
    tags: ['无删减', '下拉式', '免费', '恋爱', '青春'],
    isHot: true,
    isNew: false,
  },
  {
    id: '2',
    title: '龙拳少年',
    slug: 'longquan-shaonian',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20cover%20featuring%20a%20martial%20arts%20teenager%20with%20fiery%20red%20energy%20effects%2C%20action%20pose%2C%20clean%20white%20to%20warm%20gradient%20background%2C%20anime%20art%20style%2C%20bold%20linework%2C%20dramatic%20lighting%2C%20professional%20shonen%20manga%20cover&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    author: '烈火漫画',
    status: '连载中',
    category: '热血',
    categorySlug: 'rexue',
    description: '少年龙辰在机缘巧合下习得失传已久的龙拳秘法，从此踏上了成为最强武者的道路。一路上他遇到了志同道合的伙伴，也遭遇了强大的敌人。热血沸腾的战斗场面，感人至深的友情羁绊，尽在龙拳少年！',
    rating: 9.3,
    views: 8920000,
    chapters: [
      { id: 'ch2-1', title: '第1话 觉醒', number: 1, updatedAt: '2026-07-28' },
      { id: 'ch2-2', title: '第2话 初战', number: 2, updatedAt: '2026-07-30' },
      { id: 'ch2-3', title: '第3话 强敌', number: 3, updatedAt: '2026-08-01' },
    ],
    updatedAt: '2026-08-03',
    tags: ['热血', '格斗', '少年', '成长'],
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    title: '星海迷途',
    slug: 'xinghai-mitu',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20Chinese%20manhua%20cover%20showing%20a%20spaceship%20and%20stars%20with%20a%20young%20astronaut%2C%20deep%20space%20background%20with%20purple%20and%20blue%20nebula%20tones%2C%20anime%20art%20style%2C%20clean%20composition%2C%20professional%20manga%20cover%20design&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    author: '星河创作',
    status: '连载中',
    category: '科幻',
    categorySlug: 'kehuan',
    description: '公元2150年，人类文明已经遍布银河系。少女林星在执行一次普通的太空任务时，意外卷入了一场横跨星海的巨大阴谋。她必须在茫茫宇宙中寻找真相，同时保护自己所珍视的一切。',
    rating: 9.1,
    views: 6540000,
    chapters: [
      { id: 'ch3-1', title: '第1话 启航', number: 1, updatedAt: '2026-07-25' },
      { id: 'ch3-2', title: '第2话 迷航', number: 2, updatedAt: '2026-07-28' },
      { id: 'ch3-3', title: '第3话 遭遇', number: 3, updatedAt: '2026-08-01' },
      { id: 'ch3-4', title: '第4话 真相', number: 4, updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    tags: ['科幻', '太空', '冒险', '少女'],
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    title: '校花攻略',
    slug: 'xiaohua-gonglve',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20school%20life%20Chinese%20manhua%20cover%20with%20a%20beautiful%20schoolgirl%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20tones%2C%20clean%20white%20background%20with%20petal%20accents%2C%20anime%20art%20style%2C%20delicate%20romantic%20atmosphere%2C%20professional%20shojo%20manga%20cover&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    author: '樱花社',
    status: '已完结',
    category: '校园',
    categorySlug: 'xiaoyuan',
    description: '平凡男生李明转学到了号称"校花集中营"的星辉高中，在这里他遇到了各种各样的校花级女孩。搞笑的日常、温馨的互动、还有那份藏在心底的暗恋，一段令人捧腹又感动的校园故事就此展开。',
    rating: 8.9,
    views: 10200000,
    chapters: [
      { id: 'ch4-1', title: '第1话 转学', number: 1, updatedAt: '2026-06-15' },
      { id: 'ch4-2', title: '第2话 邂逅', number: 2, updatedAt: '2026-06-22' },
      { id: 'ch4-3', title: '第3话 同桌', number: 3, updatedAt: '2026-06-29' },
      { id: 'ch4-4', title: '第4话 心跳', number: 4, updatedAt: '2026-07-06' },
    ],
    updatedAt: '2026-07-30',
    tags: ['校园', '恋爱', '搞笑', '已完结'],
    isHot: false,
    isNew: false,
  },
  {
    id: '5',
    title: '诡案录',
    slug: 'guian-lu',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20Chinese%20manhua%20cover%20with%20a%20detective%20figure%20in%20shadows%2C%20dark%20atmospheric%20tones%20with%20warm%20accent%20lighting%2C%20mysterious%20mood%2C%20anime%20art%20style%2C%20clean%20composition%2C%20professional%20seinen%20manga%20cover&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    author: '暗夜工坊',
    status: '连载中',
    category: '悬疑',
    categorySlug: 'xuanyi',
    description: '前刑警顾城开设了一家私人侦探所，专门接手警方无法破解的诡异案件。每一个案件背后都隐藏着令人不寒而栗的真相。跟随顾城的脚步，一起揭开那些被掩埋的秘密……',
    rating: 9.4,
    views: 7310000,
    chapters: [
      { id: 'ch5-1', title: '第1话 失踪', number: 1, updatedAt: '2026-07-20' },
      { id: 'ch5-2', title: '第2话 线索', number: 2, updatedAt: '2026-07-25' },
      { id: 'ch5-3', title: '第3话 反转', number: 3, updatedAt: '2026-08-01' },
    ],
    updatedAt: '2026-08-02',
    tags: ['悬疑', '推理', '侦探', '惊悚'],
    isHot: true,
    isNew: false,
  },
  {
    id: '6',
    title: '笑傲江湖录',
    slug: 'xiaoao-jianghu-lu',
    cover: 'https://readdy.ai/api/search-image?query=A%20wuxia%20martial%20arts%20Chinese%20manhua%20cover%20with%20a%20swordsman%20on%20a%20mountain%20peak%2C%20traditional%20Chinese%20ink%20wash%20painting%20style%20blended%20with%20anime%2C%20warm%20earthy%20tones%2C%20flowing%20robes%2C%20professional%20wuxia%20manga%20cover&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    author: '剑心堂',
    status: '连载中',
    category: '武侠',
    categorySlug: 'wuxia',
    description: '少年剑客陆无双背负着家族的血海深仇，独自行走江湖。在寻找仇人的过程中，他结识了各路豪杰，也卷入了武林中的惊天阴谋。一剑在手，笑傲江湖！',
    rating: 9.2,
    views: 5780000,
    chapters: [
      { id: 'ch6-1', title: '第1话 灭门', number: 1, updatedAt: '2026-07-15' },
      { id: 'ch6-2', title: '第2话 拜师', number: 2, updatedAt: '2026-07-22' },
      { id: 'ch6-3', title: '第3话 出山', number: 3, updatedAt: '2026-07-29' },
      { id: 'ch6-4', title: '第4话 初战', number: 4, updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    tags: ['武侠', '江湖', '剑客', '复仇'],
    isHot: false,
    isNew: true,
  },
  {
    id: '7',
    title: '魔王大人住隔壁',
    slug: 'mowang-daren-zhu-gebi',
    cover: 'https://readdy.ai/api/search-image?query=A%20comedy%20fantasy%20Chinese%20manhua%20cover%20with%20a%20demon%20lord%20in%20casual%20modern%20clothes%2C%20funny%20expression%2C%20bright%20warm%20colors%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20lighthearted%20comedy%20mood%2C%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    author: '欢乐坊',
    status: '连载中',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    description: '异世界的魔王被勇者打败后，竟然穿越到了现代都市，还成了主角的隔壁邻居！曾经的魔王大人不得不学习如何适应现代生活——点外卖、挤地铁、甚至还要找工作？笑料不断的日常喜剧就此展开！',
    rating: 9.0,
    views: 8450000,
    chapters: [
      { id: 'ch7-1', title: '第1话 降临', number: 1, updatedAt: '2026-07-18' },
      { id: 'ch7-2', title: '第2话 外卖', number: 2, updatedAt: '2026-07-22' },
      { id: 'ch7-3', title: '第3话 面试', number: 3, updatedAt: '2026-07-28' },
      { id: 'ch7-4', title: '第4话 地铁', number: 4, updatedAt: '2026-08-02' },
    ],
    updatedAt: '2026-08-02',
    tags: ['搞笑', '奇幻', '穿越', '日常'],
    isHot: true,
    isNew: false,
  },
  {
    id: '8',
    title: '灵兽纪元',
    slug: 'lingshou-jiyuan',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20adventure%20Chinese%20manhua%20cover%20with%20a%20young%20tamer%20and%20a%20mythical%20phoenix%20creature%2C%20warm%20golden%20and%20orange%20tones%2C%20magical%20atmosphere%2C%20anime%20art%20style%2C%20clean%20composition%2C%20professional%20fantasy%20manga%20cover&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    author: '幻兽社',
    status: '连载中',
    category: '奇幻',
    categorySlug: 'qihuan',
    description: '在一个人与灵兽共存的世界里，少年白羽意外与传说中的上古灵兽签订了契约。从此他踏上了收集灵兽、探索世界奥秘的奇幻旅程。宏大的世界观，精美的灵兽设计，带你走进一个充满想象力的世界！',
    rating: 9.5,
    views: 9630000,
    chapters: [
      { id: 'ch8-1', title: '第1话 契约', number: 1, updatedAt: '2026-07-10' },
      { id: 'ch8-2', title: '第2话 孵化', number: 2, updatedAt: '2026-07-17' },
      { id: 'ch8-3', title: '第3话 初战', number: 3, updatedAt: '2026-07-24' },
      { id: 'ch8-4', title: '第4话 进化', number: 4, updatedAt: '2026-07-31' },
      { id: 'ch8-5', title: '第5话 宿敌', number: 5, updatedAt: '2026-08-04' },
    ],
    updatedAt: '2026-08-04',
    tags: ['奇幻', '灵兽', '冒险', '契约'],
    isHot: true,
    isNew: true,
  },
  {
    id: '9',
    title: '暗恋日记',
    slug: 'anlian-riji',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20Chinese%20manhua%20cover%20with%20a%20shy%20girl%20writing%20in%20a%20diary%2C%20soft%20pastel%20warm%20pink%20and%20peach%20tones%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20gentle%20romantic%20mood%2C%20professional%20shojo%20manga%20cover&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    author: '甜心漫画',
    status: '已完结',
    category: '恋爱',
    categorySlug: 'lianai',
    description: '高中女生苏小糖暗恋了隔壁班的篮球少年整整三年。她把自己的心事都写在了日记本里。当毕业季来临，这份暗恋会有一个美好的结局吗？温馨治愈的纯爱故事，每一页都让人心动。',
    rating: 8.8,
    views: 6890000,
    chapters: [
      { id: 'ch9-1', title: '第1话 初见', number: 1, updatedAt: '2026-05-20' },
      { id: 'ch9-2', title: '第2话 日记', number: 2, updatedAt: '2026-05-27' },
      { id: 'ch9-3', title: '第3话 接近', number: 3, updatedAt: '2026-06-03' },
    ],
    updatedAt: '2026-07-15',
    tags: ['恋爱', '暗恋', '校园', '治愈', '已完结'],
    isHot: false,
    isNew: false,
  },
  {
    id: '10',
    title: '最强赘婿',
    slug: 'zuiqiang-zhuixu',
    cover: 'https://readdy.ai/api/search-image?query=A%20powerful%20male%20lead%20Chinese%20manhua%20cover%20with%20a%20confident%20man%20in%20traditional%20Chinese%20clothing%2C%20warm%20golden%20lighting%2C%20clean%20white%20background%20with%20subtle%20gradient%2C%20anime%20art%20style%2C%20strong%20presence%2C%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    author: '龙门漫画',
    status: '连载中',
    category: '热血',
    categorySlug: 'rexue',
    description: '曾经的地下世界王者，为了一个承诺隐姓埋名成为赘婿。当家族陷入危机，他不得不重新展露锋芒。扮猪吃老虎的爽文剧情，让人欲罢不能！',
    rating: 9.1,
    views: 11050000,
    chapters: [
      { id: 'ch10-1', title: '第1话 入赘', number: 1, updatedAt: '2026-07-05' },
      { id: 'ch10-2', title: '第2话 隐忍', number: 2, updatedAt: '2026-07-12' },
      { id: 'ch10-3', title: '第3话 出手', number: 3, updatedAt: '2026-07-19' },
      { id: 'ch10-4', title: '第4话 震撼', number: 4, updatedAt: '2026-07-26' },
    ],
    updatedAt: '2026-08-01',
    tags: ['热血', '赘婿', '逆袭', '都市'],
    isHot: true,
    isNew: false,
  },
  {
    id: '11',
    title: '校园怪谈社',
    slug: 'xiaoyuan-guaitan-she',
    cover: 'https://readdy.ai/api/search-image?query=A%20school%20mystery%20Chinese%20manhua%20cover%20with%20students%20investigating%20a%20haunted%20classroom%2C%20atmospheric%20warm%20amber%20lighting%2C%20mysterious%20mood%2C%20anime%20art%20style%2C%20clean%20composition%2C%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    author: '夜谭社',
    status: '连载中',
    category: '悬疑',
    categorySlug: 'xuanyi',
    description: '一所百年名校里流传着七大不可思议的怪谈。好奇心旺盛的五个学生组成了"怪谈研究社"，他们决定逐一调查这些传闻。然而，每一个怪谈背后似乎都隐藏着真实而危险的秘密……',
    rating: 8.7,
    views: 4210000,
    chapters: [
      { id: 'ch11-1', title: '第1话 七大怪谈', number: 1, updatedAt: '2026-07-15' },
      { id: 'ch11-2', title: '第2话 音乐教室', number: 2, updatedAt: '2026-07-22' },
    ],
    updatedAt: '2026-07-30',
    tags: ['悬疑', '校园', '怪谈', '灵异'],
    isHot: false,
    isNew: true,
  },
  {
    id: '12',
    title: '机甲风暴',
    slug: 'jijia-fengbao',
    cover: 'https://readdy.ai/api/search-image?query=A%20mecha%20sci-fi%20Chinese%20manhua%20cover%20with%20a%20giant%20robot%20in%20battle%2C%20dramatic%20warm%20orange%20explosion%20lighting%2C%20anime%20art%20style%2C%20clean%20dynamic%20composition%2C%20professional%20mecha%20manga%20cover&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    author: '钢铁工厂',
    status: '连载中',
    category: '科幻',
    categorySlug: 'kehuan',
    description: '未来世界，人类依靠巨型机甲对抗来自外星的威胁。少年驾驶员方铁心驾驶着传说中的机甲"风暴号"，在战场上创造了一个又一个奇迹。热血机甲战斗，震撼视觉盛宴！',
    rating: 9.0,
    views: 5870000,
    chapters: [
      { id: 'ch12-1', title: '第1话 启动', number: 1, updatedAt: '2026-07-08' },
      { id: 'ch12-2', title: '第2话 首战', number: 2, updatedAt: '2026-07-15' },
      { id: 'ch12-3', title: '第3话 危机', number: 3, updatedAt: '2026-07-22' },
      { id: 'ch12-4', title: '第4话 突破', number: 4, updatedAt: '2026-07-29' },
    ],
    updatedAt: '2026-08-04',
    tags: ['科幻', '机甲', '战斗', '外星'],
    isHot: false,
    isNew: true,
  },
  {
    id: '13',
    title: '武林萌主',
    slug: 'wulin-mengzhu',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20wuxia%20comedy%20Chinese%20manhua%20cover%20with%20a%20chibi-style%20martial%20artist%20girl%2C%20bright%20warm%20colors%2C%20playful%20tone%2C%20anime%20art%20style%2C%20clean%20white%20background%2C%20professional%20cute%20manga%20cover&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    author: '萌趣坊',
    status: '连载中',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    description: '武林中最萌的少女侠客苏小小，虽然武功平平，但凭借可爱的外表和过人的运气，居然一路当上了武林盟主？各路英雄豪杰被她的"萌力"征服，一场搞笑的武林喜剧就此上演！',
    rating: 8.6,
    views: 4980000,
    chapters: [
      { id: 'ch13-1', title: '第1话 萌主诞生', number: 1, updatedAt: '2026-07-12' },
      { id: 'ch13-2', title: '第2话 挑战者', number: 2, updatedAt: '2026-07-19' },
      { id: 'ch13-3', title: '第3话 武林大会', number: 3, updatedAt: '2026-07-26' },
    ],
    updatedAt: '2026-08-02',
    tags: ['搞笑', '武侠', '萌系', '喜剧'],
    isHot: false,
    isNew: true,
  },
  {
    id: '14',
    title: '青春纪念册',
    slug: 'qingchun-jinian-ce',
    cover: 'https://readdy.ai/api/search-image?query=A%20youth%20slice-of-life%20Chinese%20manhua%20cover%20with%20a%20group%20of%20high%20school%20friends%2C%20warm%20sunset%20golden%20lighting%2C%20nostalgic%20mood%2C%20anime%20art%20style%2C%20clean%20composition%2C%20professional%20slice%20of%20life%20manga%20cover&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    author: '时光社',
    status: '已完结',
    category: '校园',
    categorySlug: 'xiaoyuan',
    description: '四个性格迥异的高中生，在最后一个学年里经历了欢笑、泪水、争吵与和解。这是一部关于青春、友情和梦想的群像剧。翻开这本纪念册，一起重温那段最美好的时光。',
    rating: 9.3,
    views: 7560000,
    chapters: [
      { id: 'ch14-1', title: '第1话 开学', number: 1, updatedAt: '2026-06-01' },
      { id: 'ch14-2', title: '第2话 学园祭', number: 2, updatedAt: '2026-06-08' },
      { id: 'ch14-3', title: '第3话 运动会', number: 3, updatedAt: '2026-06-15' },
    ],
    updatedAt: '2026-07-20',
    tags: ['校园', '青春', '友情', '治愈', '已完结'],
    isHot: false,
    isNew: false,
  },
  {
    id: '15',
    title: '剑仙在此',
    slug: 'jianxian-zaici',
    cover: 'https://readdy.ai/api/search-image?query=A%20sword%20immortal%20cultivation%20Chinese%20manhua%20cover%20with%20a%20floating%20swordsman%20in%20white%20robes%2C%20warm%20golden%20celestial%20light%2C%20anime%20art%20style%2C%20clean%20ethereal%20composition%2C%20professional%20xianxia%20manga%20cover&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    author: '剑心堂',
    status: '连载中',
    category: '武侠',
    categorySlug: 'wuxia',
    description: '普通少年意外获得上古剑仙传承，从此踏上修仙之路。一剑破万法，御剑行天下。且看凡人如何一步步成为传说中的剑仙，书写属于自己的传奇！',
    rating: 9.4,
    views: 9320000,
    chapters: [
      { id: 'ch15-1', title: '第1话 传承', number: 1, updatedAt: '2026-07-02' },
      { id: 'ch15-2', title: '第2话 炼气', number: 2, updatedAt: '2026-07-09' },
      { id: 'ch15-3', title: '第3话 筑基', number: 3, updatedAt: '2026-07-16' },
      { id: 'ch15-4', title: '第4话 金丹', number: 4, updatedAt: '2026-07-23' },
      { id: 'ch15-5', title: '第5话 元婴', number: 5, updatedAt: '2026-07-30' },
    ],
    updatedAt: '2026-08-04',
    tags: ['武侠', '修仙', '剑仙', '奇幻'],
    isHot: true,
    isNew: false,
  },
  {
    id: '16',
    title: '神奇动物园',
    slug: 'shenqi-dongwuyuan',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20animal%20Chinese%20manhua%20cover%20with%20magical%20creatures%20in%20a%20zoo%20setting%2C%20bright%20warm%20playful%20colors%2C%20cute%20art%20style%2C%20anime%20inspired%2C%20clean%20white%20background%2C%20professional%20children%20manga%20cover&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    author: '奇趣社',
    status: '连载中',
    category: '奇幻',
    categorySlug: 'qihuan',
    description: '小女孩朵朵发现了一个神奇的秘密——她家附近的动物园里，所有的动物都会说话！原来这些动物都是从奇幻世界来的。朵朵和她的动物朋友们一起经历了一段段奇妙又温馨的冒险。',
    rating: 8.5,
    views: 3650000,
    chapters: [
      { id: 'ch16-1', title: '第1话 秘密', number: 1, updatedAt: '2026-07-15' },
      { id: 'ch16-2', title: '第2话 朋友', number: 2, updatedAt: '2026-07-22' },
    ],
    updatedAt: '2026-07-29',
    tags: ['奇幻', '动物', '温馨', '冒险'],
    isHot: false,
    isNew: true,
  },
];

export function getComicBySlug(slug: string): Comic | undefined {
  return comics.find((c) => c.slug === slug);
}

export function getComicsByCategory(categorySlug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === categorySlug);
}

export function getHotComics(limit: number = 8): Comic[] {
  return [...comics].filter((c) => c.isHot).sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getNewComics(limit: number = 8): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
}

export function getRelatedComics(comic: Comic, limit: number = 4): Comic[] {
  return comics.filter((c) => c.id !== comic.id && (c.categorySlug === comic.categorySlug || c.tags.some((t) => comic.tags.includes(t)))).slice(0, limit);
}